import {
  RequestContext,
  Segment,
  SegmentEvaluationResult,
  SegmentEvaluatorConfig,
} from "./types";

export class SegmentEvaluator {
  private config: Required<SegmentEvaluatorConfig>;

  constructor(config: SegmentEvaluatorConfig) {
    this.config = {
      timeout: 5000,
      maxRetries: 2,
      ...config,
    };
  }

  async evaluateSegments(
    context: RequestContext
  ): Promise<SegmentEvaluationResult> {
    try {
      console.log(
        `[SegmentEvaluator] Fetching segments from ${this.config.apiEndpoint}`
      );
      const response = await fetch(this.config.apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.config.apiKey}`,
        },
        body: JSON.stringify({ context }),
      });

      if (!response.ok) {
        console.error(
          `[SegmentEvaluator] API request failed with status: ${response.status}`
        );
        const errorBody = await response.text();
        console.error(`[SegmentEvaluator] Error body: ${errorBody}`);
        // Do not throw, return a safe value
        return { segments: [], context, timestamp: Date.now(), requestId: "" };
      }

      const result = await response.json();
      console.log(`[SegmentEvaluator] Successfully received segments.`);
      return result;
    } catch (error) {
      console.error(
        "[SegmentEvaluator] Critical error during segment evaluation:",
        error
      );
      // Do not throw, return a safe value
      return { segments: [], context, timestamp: Date.now(), requestId: "" };
    }
  }
}

// Helper function to create a segment evaluator with default config
export function createSegmentEvaluator(
  config: SegmentEvaluatorConfig
): SegmentEvaluator {
  return new SegmentEvaluator(config);
}
